<template>
    <div class="">
        <div class="page-user approved modal-tab">            
            <v-tabs
                v-model="tab"
                background-color
                class="elevation-2 cust-tab"
                :centered="centered"
                tabindex="-1"
            >
                <v-tabs-slider></v-tabs-slider>
                <!-- <v-tab :href="'#0'" :disabled="question.id">Comprehension 2Q SA</v-tab>
                <v-tab :href="'#1'" :disabled="question.id">Comprehension 2Q MA</v-tab>
                <v-tab :href="'#2'" :disabled="question.id">Comprehension 3Q SA</v-tab>
                <v-tab :href="'#3'" :disabled="question.id">Comprehension 3Q MA</v-tab>-->
                <v-tab
                    v-for="(st, idx) in subTypes"
                    :key="st.id"
                    :href="'#' + idx"
                    :disabled="question.id>0"
                    tabindex="-1"
                >{{st.value}}</v-tab>

                <!-- <v-tab
                    v-for="(st, idx) in subTypes"
                    :key="st.id"
                    :href="'#' + idx"
                    :disabled="question.id"
                >{{st.value}}</v-tab> -->
            </v-tabs>
            <Comprehension2QSA
                v-if="tab==='0' || tab==='4'"
                :tab="tab"
                :question="question"
                :onNextQuestion="onNextQuestion"
				:isEditable="isEditable"
                :showNextButton="showNextButton"
            />
            <Comprehension2QMA
                v-else-if="tab==='1'"
                :tab="tab"
                :question="question"
                :onNextQuestion="onNextQuestion"
                :showNextButton="showNextButton"
				:isEditable="isEditable"
            />
            <Comprehension3QSA
                v-else-if="tab==='2'"
                :tab="tab"
                :question="question"
                :onNextQuestion="onNextQuestion"
                :showNextButton="showNextButton"
				:isEditable="isEditable"
            />
            <Comprehension3QMA
                v-else-if="tab==='3'"
                :tab="tab"
                :question="question"
				:isEditable="isEditable"
                :onNextQuestion="onNextQuestion"
                :showNextButton="showNextButton"
            />
            <Comprehension2QSAP
                v-if="tab==='5'"
                :tab="tab"
                :question="question"
                :onNextQuestion="onNextQuestion"
				:isEditable="isEditable"
                :showNextButton="showNextButton"
            />
        </div>
    </div>
</template>
<script>
import { mapActions } from "vuex";

import Comprehension2QSA from "@/components/QuestionType/Comprehensions/Comprehension2QSA.vue";
import Comprehension2QMA from "@/components/QuestionType/Comprehensions/Comprehension2QMA.vue";
import Comprehension3QSA from "@/components/QuestionType/Comprehensions/Comprehension3QSA.vue";
import Comprehension3QMA from "@/components/QuestionType/Comprehensions/Comprehension3QMA.vue";
import Comprehension2QSAP from "@/components/QuestionType/Comprehensions/Comprehension2QSAP.vue";

export default {
    name: "Comprehensions",
    props: ["question", "onNextQuestion", "showNextButton","isEditable"],
    components: {
        Comprehension2QSA,
        Comprehension2QMA,
        Comprehension3QSA,
        Comprehension3QMA,
        Comprehension2QSAP,
    },
    mounted() {
        this.updateSubType();
        this.getSubTypes();
    },
    data() {
        return {
            tab: "0",
            icons: false,
            centered: false,
            grow: false,
            vertical: false,
            prevIcon: false,
            nextIcon: false,
            right: false,
            tabs: 4,
            subTypes: []
        };
    },
    methods: {
        ...mapActions({
            getSubTypeList: "utilStore/getSubTypeList"
        }),
        getSubTypes() {
            let postData = {
                parent_id: this.question.questionType.id
            };
            this.getSubTypeList(postData)
                .then(response => {
                    this.subTypes = response;
                })
                .catch(err => {});
        },
        updateSubType() {
            if (this.question.subtype === this.QUE_TYPES.COMPREHENSION_2Q_SA) {
                this.tab = "0";
            } else if (
                this.question.subtype === this.QUE_TYPES.COMPREHENSION_2Q_MA
            ) {
                this.tab = "1";
            } else if (
                this.question.subtype === this.QUE_TYPES.COMPREHENSION_3Q_SA
            ) {
                this.tab = "2";
            } else if (
                this.question.subtype === this.QUE_TYPES.COMPREHENSION_3Q_MA
            ) {
                this.tab = "3";
            }else if (
                this.question.subtype === this.QUE_TYPES.COMPREHENSION_2Q_MM
            ) {
                this.tab = "4";
            }
            else if (
                this.question.subtype === this.QUE_TYPES.COMPREHENSION_2Q_NU
            ) {
                this.tab = "5";
            }
            if (!this.question.subtype) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_2Q_SA;
            }
        }
    },
    watch: {
        question(val) {
            this.updateSubType();
        },
        tab(val) {
            if (val == 0) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_2Q_SA;
            } else if (val == 1) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_2Q_MA;
            } else if (val == 2) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_3Q_SA;
            } else if (val == 3) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_3Q_MA;
            } else if (val == 4) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_2Q_MM;
            }else if (val == 5) {
                this.question.subtype = this.QUE_TYPES.COMPREHENSION_2Q_NU;
            }
        }
    }
};
</script>
